<template>
    <div class="d-flex" :style="$mq === 'sm' ? '' : `height: ${windowHeight - 151}px`">
        <!-- Inicio barra lateral -->
        <ContentSideBar
            showToggle
            :title="lesson.translation.name"
            style="border-right: 1px solid #E9ECEF"
            :class="`col-${windowWidth < 725 ? '12' : '3'} px-0`"
            v-model="leftBar"
            @input="v => v && this.windowWidth > 724 ? this.rightBar = false : null"
            :headerFixed="headerStatus === 'header-fixed'"
        >
            <template #header>
                <div
                    v-if="loadedLinks"
                    @click="() => navigate('home')"
                    class="card-header list-group-item-action d-flex align-items-center cursor-pointer mb-0"
                >
                    <div class="d-flex align-items-baseline">
                        <i style="font-size: 13px" class="navigation-icon fas fa-chevron-left"></i>
                        <i class="fas fa-home"></i>
                    </div>
                    <h3 class="mb-0 pl-2">{{link.home ? link.home.name : null}}</h3>
                </div>
                <!-- Barra de progresso -->
                <ProgressBar v-if="!lesson.public && !this.isPublic"
                    ref="lessonProgress"
                    class="mb-0"
                    :lesson-id="lesson.id"
                    :certificate="certificate"
                />
            </template>
            <!-- Certificado -->
            <div class="text-center p-1" v-if="showCertificate">
                <certificate-link
                    :certificate="certificate"
                    :relation="{type: 'lesson', id: lesson.id}"
                    dark
                ></certificate-link>
            </div>

            <!-- Lista conteúdo principal -->

            <LessonMainContent
                :contents="contentList.data"
                :currentContentId="currentContent.id"
                :listCurrentPage="listCurrentPage"
                :listLastPage="listLastPage"
                @setContent="setContent"
                @loadNextPage="loadNextPage"
            ></LessonMainContent>

            <!-- Listagem conteúdo final -->
            <collapse
                ref="finalContent"
                :active-index="0"
                v-if="progress === 100 && finalContent.length > 0"
            >
                <collapse-item nopadding name="final-content">
                    <template #title><h5 class="mb-0">{{$t('common.final_content')}}</h5></template>
                    <div
                        v-for="content in finalContent"
                        :key="`${content.type}-${content.id}`"
                    >
                        <!-- Adicionar exercício -->
                        <div v-if="content.type === 'exercise'">
                            <div
                                @click="getFinalExercise(content.id)"
                                class="list-group-item list-group-item-action cursor-pointer"
                            >
                                <div class="d-flex align-items-center">
                                    <i
                                        class="mdi mr-2"
                                        :class="
                                            content.completed ?
                                                'mdi-checkbox-marked' :
                                                'mdi-checkbox-blank-outline'"
                                    ></i>
                                    <h5
                                        class="side-bar-text font-weight-bold mb-0"
                                    >{{content.translation.name}}</h5>
                                </div>
                            </div>
                        </div>
                        <Topic
                            v-if="content.type === 'topic'"
                            final
                            :content="content"
                            :parents="parents"
                            @submited="getFinalContent"
                        >
                            <template #topic="{ handleTopic }">
                                <div
                                    class="list-group-item list-group-item-action cursor-pointer"
                                    @click="handleTopic"
                                >
                                    <div class="d-flex align-items-center">
                                        <i
                                            class="mdi mr-2"
                                            :class="
                                                content.completed ?
                                                'mdi-checkbox-marked' :
                                                'mdi-checkbox-blank-outline'"
                                        ></i>
                                        <h5
                                            class="side-bar-text font-weight-bold mb-0"
                                        >{{content.translation.name}}</h5>
                                    </div>
                                </div>
                            </template>
                        </Topic>
                    </div>
                </collapse-item>
            </collapse>
        </ContentSideBar>
        <!-- fim barra lateral -->

        <!-- Área do conteúdo selecionado -->
        <div
            id="content-container"
            :class="
                leftBar || rightBar ?
                    'nch--content-container col-lg-9' :
                    'nch--content-container-expand col-lg-12'"
            class="overflow-auto px-0 w-100 d-flex flex-column"
        >
            <!-- navegacao — oculta para SCORM (conteúdo tem navegação interna própria) -->
            <LessonNavigationContent
                v-if="loadedLinks && currentContent.type !== 'ScormPlayer'"
                :color="color"
                :currentContentId="currentContent.id"
                :firstContent="firstContent"
                :lastContent="lastContent"
                :contentList="contentList"
                :parents="parents"
                :submodules="submodules"
                @navigate="navigate($event)"
                @navigateContent="navigateContent($event)"
            />
            <!-- Renderiza conteúdo na tela -->

            <!-- Conteúdo: Cabeçalho -->
            <component
                ref="content-header"
                :is="currentContent.header"
                v-model="contentData"
            ></component>
            <!-- Conteúdo: Corpo -->
            <component
                v-if="currentContent.id"
                ref="content"
                :class="currentContent.type === 'ScormPlayer' ? 'd-flex w-100 flex-grow-1 my-0 p-0' : 'd-flex stretch w-100 card my-0'"
                v-model="contentData"
                :user="user"
                :is="currentContent.type"
                :contentId="currentContent.id"
                :lessonId="lesson.id"
                :exercise-progress="false"
                :lesson="lesson"
                :parents="parents"
                :exerciseFinal="currentContent"
                :isPublic="isPublic"
                @contentSubmited="getList"
                @contentClicked="setContent"
                @side="toggleRightSideBar"
                @liveSettings="onChangeLiveSettings"
                @progress="updateProgress"
            ></component>

            <!-- Conteúdo nao selecionado: visão Geral da Aula -->
            <div v-else class="flex d-flex flex-grow-1 flex-column">
                <div class="flex header" :style="$bgColor(color.primary)">
                    <div class="header-body">
                        <div class="card my-4 mx-2 px-2 py-2">
                            <h1 class="py-2 mb-0">{{lesson.translation.name}}</h1>
                        </div>
                    </div>
                </div>
                <div
                    class="flex flex-grow-1 card py-4 px-4 my-0 ql-editor"
                    v-html="lesson.translation.description"
                ></div>
            </div>
        </div>

        <!-- chat utlizado na live e videoconferencia -->
        <ContentSideBar
            v-if="rightSideBar.component"
            right
            title="common.chat"
            :class="`col-${windowWidth < 725 ? '12' : '3'} px-0`"
            v-model="rightBar"
            @input="(value) => toggleRightSideBar({value})"
            :showToggle="!!rightSideBar.component"
            icon="mdi mdi-chat"
            :info="rightSideBar.value.moderate ? 'Moderação Ativada' : null"
        >
            <component
                ref="rightBar"
                :rightBar="rightBar"
                :is="rightSideBar.component"
                :user="user"
                :model-value="rightSideBar.value"
                :disabled="rightSideBar.disabled"
                @liveSettings="onChangeLiveSettings"
            ></component>
        </ContentSideBar>
    </div>
</template>

<script>
import VideoContent from '../components/LessonContentComponents/LessonContentVideo';
import upload from '../components/LessonContentComponents/LessonContentUpload';
import ScormPlayer from '../components/LessonContentComponents/ScormPlayer';
import AttendanceContent from '../components/LessonContentComponents/AttendanceContent';
import ExerciseHeader from '../components/ExerciseComponents/ExerciseHeader';
import CertificateLink from '../components/Certificate/CertificateLink';
import ChatLive from './ChatComponents/ChatLive';
import ProgressBar from './Common/ProgressBar';
import Exercise from '../components/Exercise';
import Topic from '../components/Common/TopicComponents/Topic';
import Forum from '../components/Forum';
import LessonMainContent from '../components/LessonComponents/LessonMainContent';
import LessonNavigationContent from '../components/LessonComponents/LessonNavigationContent';

import Tabs from '../argon/components/Tabs/Tabs';
import TabPane from '../argon/components/Tabs/Tab';
import BaseButton from '../argon/components/BaseButton';
import Collapse from '../argon/components/Collapse/Collapse';
import ContentSideBar from './ContentComponents/ContentSideBar';
import CollapseItem from '../argon/components/Collapse/CollapseItem';

export default {
    name: 'Lesson',

    props: {
        parents: {
            type: Object,
            required: true,
        },
        lesson: {
            type: Object,
            required: true,
            description: 'Prop recebida através do blade',
        },
        user: Object,
        certificate: {
            type: Object,
        },
        isPublic: {
            type: Boolean,
            default: false,
            description: 'Indica se a aula está sendo acessada via URL pública assinada',
        },
    },
    components: {
        ContentSideBar,
        LessonNavigationContent,
        ChatLive,
        BaseButton,
        Exercise,
        upload,
        ProgressBar,
        VideoContent,
        ScormPlayer,
        AttendanceContent,
        Tabs,
        TabPane,
        Forum,
        CollapseItem,
        Collapse,
        CertificateLink,
        ExerciseHeader,
        Topic,
        LessonMainContent,
    },
    data() {
        return {
            leftBar: true,
            rightBar: false,
            rightSideBar: {},
            contentData: {},
            loaded: false,
            content: [],
            currentContent: {},
            list: [],
            meta: {},
            links: {},
            forum: null,
            lastContent: false,
            firstContent: true,
            currentIndex: 0,
            listCurrentPage: null,
            listLastPage: null,
            loadedLinks: false,
        };
    },
    watch: {
        currentIndex(newVal, oldVal) {
            this.navigationControl(newVal, oldVal);
        },
    },

    computed: {
        windowHeight() {
            return document.documentElement.clientHeight;
        },
        windowWidth() {
            return document.documentElement.clientWidth;
        },

        layout() {
            return this.$store.getters.NAVBAR_FIXED;
        },

        color() {
            return this.$store.getters.COLOR;
        },

        language() {
            return this.$store.getters.LANGUAGE;
        },

        headerStatus() {
            if (this.layout) return 'header-fixed';
            return 'header-not-fixed';
        },

        contentList() {
            return this.$store.getters.LOADED_LIST_CONTENT;
        },

        finalContent() {
            return this.$store.getters.LOADED_FINAL_CONTENT;
        },

        progress() {
            return this.$store.getters.LOADED_PROGRESS;
        },

        showCertificate() {
            let certificateProgress = 0;

            if (this.certificate && this.certificate.progress) {
                certificateProgress = parseInt(this.certificate.progress);
            }

            if (this.certificate && this.progress && this.progress >= certificateProgress) {
                return true;
            }

            return false;
        },

        finalExercise() {
            return this.$store.getters.LOADED_FINAL_EXERCISE;
        },

        link() {
            return this.$store.getters.LOADED_CONTENT_LINKS;
        },
        submodules() {
            const submodules = new URLSearchParams(window.location.search);
            return submodules.getAll('submodules[]');
        },
    },

    watch: {
        // getFinalContent() só era chamado uma vez no mounted(); se o aluno
        // completa o último conteúdo durante a sessão (sem reload), o bloco
        // de conteúdo final nunca era buscado mesmo com progress virando 100.
        progress(value) {
            if (value === 100 && !this.finalContent.length) {
                this.getFinalContent();
            }
        },
    },

    methods: {
        loadNextPage() {
            this.listCurrentPage = this.listCurrentPage + 1;
            this.getContentList(true);
        },

        async navigateContent(direction) {
            await this.getLinks();
            if (direction === 'next' && this.link.next) {
                location.href = this.link.next.url;
            } else if (direction === 'prev' && this.link.prev) {
                location.href = this.link.prev.url;
            }
        },

        navigate(direction) {
            const listLength = this.contentList.data.length;
            switch (direction) {
            case 'next':
                if (listLength > this.currentIndex + 1) {
                    this.setContent(
                        this.contentList.data[this.currentIndex + 1],
                    );
                }
                break;
            case 'prev':
                if (listLength > this.currentIndex) {
                    this.setContent(
                        this.contentList.data[this.currentIndex - 1],
                    );
                }
                break;
            case 'home':
                if (this.link && this.link.home) {
                    location.href = this.link.home.url;
                } else {
                    location.href = `${window.location.origin}/app/dashboard`;
                }
                break;
            default:
                break;
            }
        },

        navigationControl(newVal, oldVal) {
            const listLength = this.contentList.data.length;

            if (oldVal === 0) {
                this.firstContent = false;
            }
            if (oldVal !== listLength) {
                this.lastContent = false;
            }
            if (newVal === 0) {
                this.firstContent = true;
            }
            if (newVal + 1 === listLength) {
                this.lastContent = true;
            }
        },

        async setContent(content) {
            if (content.lock) {
                this.$notify({
                    type: 'warning',
                    message: content.lock_message,
                });
                return;
            }

            this.$loading.show();

            await this.getContent(content.id);

            await this.$store.dispatch('GET_CONTENT_PROGRESS');

            this.currentContent = JSON.parse(JSON.stringify(content));
            this.currentIndex = this.contentList.data.indexOf(content);

            this.$loading.close();

            const type = content.type
                ? content.type.toLocaleLowerCase()
                : content.type;
            if (type === 'video') {
                this.currentContent.type = 'VideoContent';
                return;
            } else if (type === 'scorm') {
                this.currentContent.type = 'ScormPlayer';
            } else if (type === 'attendance') {
                this.currentContent.type = 'AttendanceContent';
            } else if (type === 'exercise') {
                this.currentContent.header = 'ExerciseHeader';
            }
            if (this.leftBar && this.windowWidth < 725) this.leftBar = false;
        },
        getContent(contentId) {
            // URLs assinadas são SÓ para acesso anônimo (isPublic). Aluno
            // autenticado usa as rotas normais — aula marcada como pública não
            // muda isso (backlog#410: a URL assinada expira/quebra o pdf.js).
            if (this.isPublic) {
                const signedApiUrls = localStorage.getItem(`lesson_${this.parents.lessonId}_api_urls`);

                if (signedApiUrls) {
                    const apiUrls = JSON.parse(signedApiUrls);
                    // Se temos URLs assinadas para downloads e é um upload/vídeo
                    if (apiUrls && apiUrls.downloads && apiUrls.downloads[contentId]) {
                        // Armazenar URLs de download e visualização para este conteúdo
                        localStorage.setItem(
                            `content_${contentId}_download_urls`,
                            JSON.stringify(apiUrls.downloads[contentId]),
                        );
                    }
                }
            } else {
                // Remove restos de um acesso público anterior no mesmo navegador —
                // os componentes de conteúdo (ContentPDF etc.) priorizam essas
                // chaves e uma URL assinada vencida derrubaria o arquivo (403).
                localStorage.removeItem(`content_${contentId}_download_urls`);
            }

            // Usar o store para carregar o conteúdo
            this.$store
                .dispatch('LOAD_CONTENT', {
                    id: this.lesson.id,
                    iso: this.language.iso,
                    submodules: this.submodules,
                    moduleId: this.parents.moduleId,
                    plan: this.parents.planId,
                    lesson: this.parents.lessonId,
                    course: this.parents.courseId,
                    public: this.lesson.public || this.isPublic,
                    contentId,
                })
                .then((this.loaded = true));
        },
        async getContentList(pagination = false) {
            this.$loading.show();

            // URLs assinadas só no acesso anônimo (ver getContent — backlog#410)
            if (this.isPublic && !pagination) {
                const signedApiUrls = localStorage.getItem(`lesson_${this.parents.lessonId}_api_urls`);

                if (signedApiUrls) {
                    const apiUrls = JSON.parse(signedApiUrls);
                    if (apiUrls && apiUrls.contents) {
                        // Se temos uma URL assinada para contents, usamos ela
                        return window.axios
                            .get(apiUrls.contents)
                            .then((res) => {
                                this.$store.commit('SET_LIST_CONTENT', {
                                    data: res.data,
                                    pagination,
                                });
                                this.$loading.close();
                            })
                            .catch((err) => {
                                console.error(err);
                                this.$loading.close();
                            });
                    }
                }
            }

            // Se não temos URL assinada ou não é acesso público, usamos a rota normal
            await this.$store
                .dispatch('LOAD_LIST_CONTENT', {
                    parents: this.parents,
                    id: this.lesson.id,
                    iso: this.language.iso,
                    per_page: 20,
                    page: this.listCurrentPage,
                    pagination,
                    submodules: this.submodules,
                    public: this.lesson.public || this.isPublic,
                })
                .then(this.$loading.close());
        },
        getList(final) {
            if (final) {
                this.getFinalContent();
            } else {
                this.getContentList();
            }
        },
        getForumList() {
            this.$loading.show();
            window.axios
                .get(
                    `/api/app/lesson/${this.lesson.id}/forum/${this.lesson.forum.id}`,
                )
                .then((res) => {
                    this.forum = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.$loading.close();
                });
        },

        toggleRightSideBar({ component, value, data }) {
            if (component === 'ChatLive') {
                this.rightSideBar.component = data && data.chat ? component : false;
                this.rightSideBar.disabled = data && data.live ? 0 : 1;
                if (data && data.chat) {
                    const chatType = data.chat_type || 'lv';
                    const name = `NCH_${chatType.toUpperCase()}_${data.id}`;
                    this.rightSideBar.value = {
                        room_id: data.id,
                        name,
                        status: data.chat,
                        history: data.chat_save,
                        moderate: data.chat_mod,
                        type: chatType,
                    };
                }
            }
            this.rightBar = value;
            if (this.windowWidth > 724) this.leftBar = !value;
        },

        onChangeLiveSettings({ settings, room }) {
            if (this.rightSideBar.component === 'ChatLive') {
                this.rightSideBar = {
                    ...this.rightSideBar,
                    value: room,
                    disabled: settings.live ? 0 : 1,
                };
            }
            this.contentData.settings = settings;
        },
        getFinalContent() {
            // URLs assinadas só no acesso anônimo (ver getContent — backlog#410)
            if (this.isPublic) {
                const signedApiUrls = localStorage.getItem(`lesson_${this.parents.lessonId}_api_urls`);

                if (signedApiUrls) {
                    const apiUrls = JSON.parse(signedApiUrls);
                    if (apiUrls && apiUrls.finalContents) {
                        // Se temos uma URL assinada para finalContents, usamos ela
                        return window.axios
                            .get(apiUrls.finalContents)
                            .then((res) => {
                                this.$store.commit('SET_FINAL_CONTENT', res.data.data);
                            })
                            .catch(err => console.error(err));
                    }
                }
            }

            // Se não temos URL assinada, usamos a rota normal
            this.$store.dispatch('LOAD_FINAL_CONTENT', {
                parents: this.parents,
                submodules: this.submodules,
                public: this.lesson.public || this.isPublic,
            });
        },
        getFinalExercise(exerciseId) {
            this.$store
                .dispatch('LOAD_FINAL_CONTENT_EXERCISE', {
                    parents: this.parents,
                    id: exerciseId,
                    submodules: this.submodules,
                    public: this.lesson.public || this.isPublic,
                })
                .then(async () => {
                    await this.$store.commit('SET_EXERCISE', {
                        exercise: this.finalExercise,
                        type: 'exercise',
                    });
                    this.currentContent = {
                        header: 'ExerciseHeader',
                        type: 'exercise',
                        id: this.finalExercise.id,
                        final: true,
                    };
                    if (this.leftBar && this.windowWidth < 725) this.leftBar = false;
                });
        },
        getLinks() {
            // URLs assinadas só no acesso anônimo (ver getContent — backlog#410)
            if (this.isPublic) {
                const signedApiUrls = localStorage.getItem(`lesson_${this.parents.lessonId}_api_urls`);

                if (signedApiUrls) {
                    const apiUrls = JSON.parse(signedApiUrls);
                    if (apiUrls && apiUrls.links) {
                        return this.$store
                            .dispatch('LOAD_LINKS', {
                                parents: this.parents,
                                submodules: this.submodules,
                                signedUrl: apiUrls.links,
                                public: true,
                            })
                            .then(() => {
                                this.loadedLinks = true;
                            });
                    }
                }
            }

            // Se não temos URL assinada, usamos a rota normal ou buscamos as URLs assinadas do servidor
            if (this.isPublic) {
                // Se estamos em acesso público, vamos buscar as URLs assinadas
                return window.axios
                    .get(`/api/app/public/plan/${this.parents.planId}/lesson/${this.parents.lessonId}/signed-url`)
                    .then((response) => {
                        // Armazenar as URLs assinadas no localStorage
                        localStorage.setItem(
                            `lesson_${this.parents.lessonId}_api_urls`,
                            JSON.stringify(response.data.api),
                        );

                        // Usar a URL assinada para links
                        return this.$store
                            .dispatch('LOAD_LINKS', {
                                parents: this.parents,
                                submodules: this.submodules,
                                signedUrl: response.data.api.links,
                                public: true,
                            })
                            .then(() => {
                                this.loadedLinks = true;
                            });
                    })
                    .catch((err) => {
                        console.error('Erro ao buscar URLs assinadas:', err);
                        // Em caso de erro, tentamos a rota normal
                        return this.$store
                            .dispatch('LOAD_LINKS', {
                                parents: this.parents,
                                submodules: this.submodules,
                                public: true,
                            })
                            .then(() => {
                                this.loadedLinks = true;
                            });
                    });
            }

            // Para acessos não públicos, usamos a rota normal
            return this.$store
                .dispatch('LOAD_LINKS', {
                    parents: this.parents,
                    submodules: this.submodules,
                    public: this.lesson.public || this.isPublic,
                })
                .then(() => {
                    this.loadedLinks = true;
                });
        },
        updateProgress({ progress }) {
            const $bar = this.$refs.lessonProgress;
            this.$store.commit('CHANGE_CONTENT', { id: this.currentContent.id, progress });
            if ($bar && $bar.getProgress) {
                $bar.getProgress();
            }
        },
    },

    async mounted() {
        // Carregamos as URLs assinadas primeiro para acessos públicos
        await this.getLinks();

        await this.getFinalContent();
        await this.getContentList().then(() => {
            this.listCurrentPage = this.contentList.meta.current_page;
            this.listLastPage = this.contentList.meta.last_page;
        });

        if (this.lesson.forum_id) {
            this.getForumList();
        }

        if (this.windowWidth < 725) {
            this.leftBar = false;
            setTimeout(() => {
                this.toggleRightSideBar({ component: undefined, value: false });
            }, 500);
        } else {
            this.leftBar = true;
        }

        await this.$store.dispatch('GET_CONTENT_PROGRESS');
    },
};
</script>

<style scoped>
.nch--content-upper-menu {
    height: 55px;
}

::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    border-radius: 0;
}

::-webkit-scrollbar-thumb {
    margin: 2px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
}

.stretch {
    height: 100%;
    overflow: auto;
    border-radius: 0;
}
</style>
